import React from 'react';
import { format, parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz'; // Importação correta de toZonedTime
import { ptBR } from 'date-fns/locale/pt-BR';

import { Column } from "../Layout/Grid";
import Text from "../Text";

import trackingOpen from "img/tracking-open.svg";
import trackingDone from "img/tracking-done.svg";
import trackingRefused from "img/tracking-error.svg";

import DateOutput from "utils/DateOutput";
import { isMobileDevice } from 'utils/ScreenUtils';

import { ITrackItem } from './interface';
import { TrackItemStyled } from './styles';

const TrackItem: React.FC<ITrackItem> = (props) => {
  const { item, lastItemWithDate, indexCurrentItem, trackingTypes } = props;
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

  const dateStr = item.eventDate ? `${item.eventDate}` : null;
  const zonedDate = dateStr ? toZonedTime(parseISO(dateStr), timeZone) : null;
  const dateValid = zonedDate ? format(zonedDate, 'HH:mm', { locale: ptBR }) : null;
  const isMobile = isMobileDevice();

  const nextIndex = indexCurrentItem + 1;
  const nextItem = trackingTypes[nextIndex];

  function getStatusValue(): string {
    return item.value ?? "";
  }

  const setTrackingIcon = (key: string | undefined) => {
    let refusedList = ["REFUSED", "DELIVERY_OCCURRENCE"];
    if (key && lastItemWithDate > indexCurrentItem) {
      return refusedList.includes(key) ?
        (<img src={trackingRefused} alt="" />) :
        (<img src={trackingDone} alt="" />);
    } else {
      if (key && item?.eventDate) {
        return refusedList.includes(key) ?
          (<img src={trackingRefused} alt="" />) :
          (<img src={trackingDone} alt="" />);
      }
      return (<img src={trackingOpen} alt="" />);
    }
  };

  const itemStyleOpacity = () => {
    if (lastItemWithDate > indexCurrentItem)
      return 1;

    return item.eventDate ? 1 : 0.5;
  };

  const styleItem = {
    opacity: itemStyleOpacity(),
    width: 100,
    maxWidth: 100,
  };

  const renderViewMobile = () => {
    return (
      <TrackItemStyled isMobile={isMobile}>
        <Column className="align-center">
          {setTrackingIcon(item.key)}
          {indexCurrentItem !== trackingTypes.length - 1 && <Column className={`tracking-vertical-line ${lastItemWithDate > nextIndex || !!nextItem?.eventDate ? 'bg-normal' : 'bg-faded'}`} />}
        </Column>
        <Column>
          <Text
            size={14}
            className="mt-1 color-blue-gray text-left text-wrap text-overflow-none text-uppercase-first-letter font-bold"
            width={200}
          >
            {getStatusValue()}
          </Text>
          <Text size={13} className="color-blue-gray text-left">
            {item.eventDate ? (
              <DateOutput dateStr={item.eventDate} patternStr={"dd/MM/yyyy"} />
            ) : ("-")} {` | `}
            {item.eventDate && item.key !== 'BILLING' && dateValid && dateValid !== '00:00' ? (
              <DateOutput dateStr={item.eventDate} patternStr={"HH:mm"} />
            ) : ("-")}
          </Text>
        </Column>
      </TrackItemStyled>
    );
  };

  const renderViewDefault = () => {
    return (
      <TrackItemStyled>
        <Column
          className="align-center"
          style={styleItem}
        >
          {setTrackingIcon(item.key)}
          <Text
            size={14}
            className="mt-1 color-blue-gray text-center text-wrap text-overflow-none flex-1 text-uppercase-first-letter"
            width={90}
          >
            {getStatusValue()}
          </Text>
          <Column className="align-center mt-2">
            <Text size={12} className="color-blue-gray text-center">
              {item.eventDate ? (
                <DateOutput dateStr={item.eventDate} patternStr={"dd/MM/yyyy"} />
              ) : ("-")}
            </Text>
            <Text size={12} className="color-blue-gray text-center">
              {item.eventDate && item.key !== 'BILLING' && dateValid && dateValid !== '00:00' ? (
                <DateOutput dateStr={item.eventDate} patternStr={"HH:mm"} />
              ) : ("-")}
            </Text>
          </Column>
        </Column>
      </TrackItemStyled>
    );
  };

  const renderView = () => {
    if (isMobile) {
      return renderViewMobile();
    }

    return renderViewDefault();
  };

  return renderView();
};

export default TrackItem;
